import React from 'react';
import {
  PageHeaderContainer,
  PageTitle,
  PageDescription,
} from './PageHeader.styles';

export default function PageHeader({ title, description }) {
  return (
    <PageHeaderContainer>
      <PageTitle variant="h1">{title}</PageTitle>
      {description && <PageDescription variant="body1">{description}</PageDescription>}
    </PageHeaderContainer>
  );
};